import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {PromotedSponsorshipModuleController} from "../promoted-sponsorship-module.controller";

export class PromotedSponsorshipModuleProps extends BaseModuleProps {
  controller: PromotedSponsorshipModuleController;
}
